export default {
	validators: {
		'email': 'required_without:mobile|email',
		'mobile': 'required_without:email',
		'password': 'required'
	},
	messages: {
		"required_without.email": "login_email_required",
		"email.email": "login_email_invalid",
		"required_without.mobile": "login_mobile_required",
		"required.password": "login_password_required"
	}
}